import React, { useEffect, useState } from "react";
import { getUserAccount } from "../services/userServices";
import { toAuthState } from "../dto/auth.dto";

const AdminContext = React.createContext(null);

const AdminProvider = ({ children }) => {
  const initialState = { isLoading: true, isAuthenticated: false, account: {}, userData: {}, adminData: {} };
  const [admin, setAdmin] = useState(initialState);

  useEffect(() => {
    getUserAccount()
      .then((response) => setAdmin(toAuthState(response, 'admin') || { ...initialState, isLoading: false }))
      .catch(() => setAdmin({ ...initialState, isLoading: false }));
  }, []);

  return (
    <AdminContext.Provider value={{
      admin,
      loginContext: (data) => setAdmin({ ...data, isLoading: false }),
      logoutContext: () => setAdmin({ ...initialState, isLoading: false }),
    }}>
      {children}
    </AdminContext.Provider>
  );
};

export { AdminContext, AdminProvider };
